import { track } from '@mc/track-event'
import { CheckoutEvents } from '../../lib/constants'

interface TrackPasswordVisibilityToggledProps {
  visible: boolean
  location: string
  pageSource: string
}

export const trackPasswordVisibilityToggled = ({
  visible,
  location,
  pageSource,
}: TrackPasswordVisibilityToggledProps) => {
  track(
    visible
      ? CheckoutEvents.EVENTS.PASSWORD_SHOW
      : CheckoutEvents.EVENTS.PASSWORD_HIDE,
    {
      location,
      page_source: pageSource,
    },
  )
}
